export default "__VITE_ASSET__CyGt$Rys__"